module.exports = __webpack_public_path__ + "img/tick.b3f4c23d.svg";